export const AGENT_GUIDE_ACTIONS = {
    EDIT_GUIDE: "EDIT_GUIDE",
    DELETE_GUIDE: "DELETE_GUIDE",
    VIEW_GUIDE: "VIEW_GUIDE",
    CREATE_GUIDE: "CREATE_GUIDE",
};
